import { useParams, Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { navCategories } from '@/mocks/home';
import { allArticles, categorySlugMap } from '@/mocks/articles';

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const currentSlug = slug || 'heiliao-jinri';
  const categoryName = categorySlugMap[currentSlug] || '未分类';
  const articles = allArticles.filter((a) => a.categorySlug === currentSlug);

  return (
    <>
      <Navbar categories={navCategories} />
      <main className="pt-20 md:pt-24">
        <div className="max-w-[1400px] mx-auto px-4 md:px-6">
          <nav className="flex items-center gap-2 text-sm text-foreground-500 mb-6">
            <Link to="/" className="hover:text-primary-500 transition-colors">首页</Link>
            <i className="ri-arrow-right-s-line text-xs"></i>
            <span className="text-foreground-800 font-medium">{categoryName}</span>
          </nav>

          <div className="mb-8">
            <h1 className="text-3xl md:text-5xl font-heading font-black text-foreground-950">
              {categoryName}
            </h1>
            <p className="mt-3 text-foreground-500 text-sm max-w-[600px]">
              {categorySlugMap[currentSlug]
                ? `浏览「${categoryName}」分类下的所有爆料内容，每日更新，吃瓜不停。`
                : '浏览所有分类内容'}
            </p>
          </div>

          <div className="flex items-center gap-2 overflow-x-auto pb-2 mb-8 scrollbar-hide">
            {Object.entries(categorySlugMap).map(([catSlug, catName]) => (
              <Link
                key={catSlug}
                to={`/category/${catSlug}`}
                className={`px-5 py-2.5 rounded-full text-sm font-medium whitespace-nowrap transition-all duration-200 cursor-pointer ${
                  currentSlug === catSlug
                    ? 'bg-foreground-950 text-background-50'
                    : 'bg-background-100 text-foreground-600 hover:bg-background-200'
                }`}
              >
                {catName}
              </Link>
            ))}
          </div>

          {articles.length > 0 ? (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6 pb-16">
              {articles.map((article) => (
                <Link
                  key={article.id}
                  to="/category/all"
                  className="group rounded-2xl overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-300 transition-all duration-300 cursor-pointer flex flex-col"
                >
                  <div className="relative aspect-[16/10] overflow-hidden">
                    <img
                      src={article.image}
                      alt={article.title}
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                      loading="lazy"
                    />
                    {article.hot && (
                      <div className="absolute top-3 left-3 px-2.5 py-1 rounded-full bg-primary-500 text-background-50 text-xs font-medium flex items-center gap-1">
                        <i className="ri-fire-line text-[10px]"></i>
                        热门
                      </div>
                    )}
                  </div>
                  <div className="p-4 md:p-5 flex-1 flex flex-col">
                    <h3 className="text-foreground-900 text-base font-bold leading-snug line-clamp-2 group-hover:text-primary-600 transition-colors">
                      {article.title}
                    </h3>
                    <p className="mt-2 text-foreground-500 text-sm line-clamp-2 flex-1">{article.excerpt}</p>
                    <div className="flex items-center justify-between mt-4 pt-3 border-t border-background-200">
                      <span className="text-foreground-400 text-xs">{article.date}</span>
                      <span className="text-foreground-400 text-xs flex items-center gap-1">
                        <i className="ri-eye-line"></i>
                        {article.views}
                      </span>
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          ) : (
            <div className="text-center py-20">
              <div className="w-16 h-16 mx-auto flex items-center justify-center rounded-full bg-background-100 text-foreground-400">
                <i className="ri-inbox-line text-2xl"></i>
              </div>
              <h3 className="mt-4 text-foreground-700 font-medium">暂无内容</h3>
              <p className="mt-1 text-foreground-400 text-sm">该分类下暂时没有文章，请稍后再来</p>
            </div>
          )}

          <div className="text-center pb-16">
            <Link
              to="/"
              className="inline-flex items-center gap-2 bg-foreground-950 text-background-50 px-8 py-3 rounded-full text-sm font-semibold hover:bg-foreground-800 transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-arrow-left-line"></i>
              返回首页
            </Link>
          </div>
        </div>
      </main>
      <Footer />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'CollectionPage',
            name: `${categoryName} - 今日看料`,
            description: `今日看料「${categoryName}」分类页面，每日更新最新${categoryName}相关爆料内容。`,
            url: `http://hlw51.cn/category/${currentSlug}`,
            isPartOf: {
              '@type': 'WebSite',
              name: '今日看料',
              url: 'http://hlw51.cn/',
            },
            breadcrumb: {
              '@type': 'BreadcrumbList',
              itemListElement: [
                { '@type': 'ListItem', position: 1, name: '首页', item: 'http://hlw51.cn/' },
                { '@type': 'ListItem', position: 2, name: categoryName, item: `http://hlw51.cn/category/${currentSlug}` },
              ],
            },
            mainEntity: {
              '@type': 'ItemList',
              itemListElement: articles.slice(0, 20).map((a, idx) => ({
                '@type': 'ListItem',
                position: idx + 1,
                item: {
                  '@type': 'Article',
                  name: a.title,
                  url: `http://hlw51.cn/article/${a.slug}`,
                  headline: a.title,
                  description: a.excerpt,
                  datePublished: a.date,
                },
              })),
            },
          }),
        }}
      />
    </>
  );
}